import { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${BACKEND_URL}/api`;
import { useToast, toast } from './use-toast';
// import { toast } from 'sonner';

const useAxios = (headers = {}, redirectLogin = false, toastError = false) => {
  // const toast = useToast();
  const navigate = useNavigate();
  const getAuthHeaders = useCallback(() => {
    const token = localStorage.getItem('user_token');
    if (!token) {
      return null;
    }
    if (redirectLogin) navigate('/login');
    return { Authorization: `Bearer ${token}` };
  }, [navigate, redirectLogin]);

  const axiosInstance = useMemo(() => {
    return axios.create({
      baseURL: BASE_URL,
      headers,
      // timeout: 10000,
    });
  }, [headers]);

  axiosInstance.interceptors.request.use(
    (config) => {
      const authHeaders = getAuthHeaders();
      if (authHeaders) {
        config.headers = {
          ...config.headers,
          ...authHeaders,
        };
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  axiosInstance.getFile = async (url) => {
    try {
      const response = await axiosInstance.get(url, {
        responseType: 'arraybuffer',
      });

      // Ambil content-type dari header
      const contentType = response.headers['content-type'] || 'application/octet-stream';

      // Convert buffer ke base64
      const base64String = Buffer.from(response.data, 'binary').toString('base64');

      // Return data URI (opsional, bisa langsung base64String saja)
      return `data:${contentType};base64,${base64String}`;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401 && token) {
        toast({ title: 'Session Expired', description: 'Please login again' });
        navigate('/login');
      } else {
        console.error(error);
        if (toastError) {
          toast({
            title: 'Oops, Something went wrong',
            description: error.response?.data?.detail || error.response?.data?.message || 'Please try again later',
            icon: 'circle-alert',
          });
        }
      }
      return Promise.reject(error);
    },
  );
  return axiosInstance;
};

export default useAxios;
